module.exports = __webpack_public_path__ + "img/login.74809f3c.svg";